import React from 'react';

import loadingGif from '../static/images/heavylogointrohorizonatal_done.gif';

const Loading = () => (
  <img
    className="loading"
    src={loadingGif}
    alt="Loading..."
  />
);

export default Loading;
